import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/material/styles';
import { EmbersMenuList } from '../menuList';
import { PROMETHEAN_TYPOGRAPHY_SUBTITLE_04 } from '../styles/typography/typography';
import { PROMETHEAN_NEUTRAL_PLUM, PROMETHEAN_NEUTRAL_WHITE } from '../styles';
export var StyledTitledMenuList = styled(EmbersMenuList)(function () {
  return {
    '&.MuiList-root': {
      '&.MuiList-padding': {
        padding: 0
      },
      '.MuiMenuItem-root.EmbersMenuItem-checkable': {
        paddingLeft: 16,
        paddingRight: 24,
        marginTop: 0,
        marginBottom: 0,
        height: 32,
        ' span': {
          height: 32
        },
        '.MuiTypography-root': {
          paddingTop: 4,
          paddingBottom: 4,
          letterSpacing: 0
        },
        '&:active, &.Mui-selected': {
          '&:before': {
            width: 0
          },
          '&.Mui-selected': {
            backgroundColor: PROMETHEAN_NEUTRAL_WHITE
          },
          '&:hover': {
            background: PROMETHEAN_NEUTRAL_PLUM
          },
          '&.Mui-focusVisible': {
            background: PROMETHEAN_NEUTRAL_PLUM
          }
        },
        '&:hover': {
          background: PROMETHEAN_NEUTRAL_PLUM
        },
        '&.Mui-focusVisible': {
          background: PROMETHEAN_NEUTRAL_PLUM
        },
        '&:last-child': {
          marginBottom: 24
        }
      }
    }
  };
});
export var StyledMenuTitle = styled('div')(function () {
  return _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04), {}, {
    padding: '16px 24px 2px 24px',
    '&.Mui-disabled': {
      opacity: 1
    }
  });
});